import { render, staticRenderFns } from "./Swipper.vue?vue&type=template&id=0d028bd9&scoped=true&"
import script from "./Swipper.vue?vue&type=script&lang=js&"
export * from "./Swipper.vue?vue&type=script&lang=js&"
import style0 from "./Swipper.vue?vue&type=style&index=0&id=0d028bd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d028bd9",
  null
  
)

export default component.exports